module.exports = __webpack_public_path__ + "static/media/ms_logo.2587d5f9.png";